import { ButtonGroup, IconButton, LuIcon, Text } from "@overmap-ai/blocks"
import type { Table } from "@tanstack/react-table"

import { modelIconMapping } from "../../../mappings/icons"
import { genericMemo } from "../../../utils/optimization"
import { RowsPerPageSelect } from "./RowsPerPageSelect"

interface PaginationControlProps<TData> {
	table: Table<TData>
	rowPerPageOptions?: number[]
}

export const PaginationControl = genericMemo(function <TData>(props: PaginationControlProps<TData>) {
	const { table, rowPerPageOptions } = props

	return (
		<ButtonGroup className="grid w-full grid-cols-3" size="xs" variant="soft" accentColor="base">
			<div className="flex h-max grow items-center gap-2">
				<RowsPerPageSelect
					selectedRowsPerPage={table.getState().pagination.pageSize}
					onRowsPerPageChange={table.setPageSize}
					rowsPerPageOptions={rowPerPageOptions}
				/>
				<Text size="sm" accentColor="base">
					Total: {table.getRowCount()}
				</Text>
			</div>

			<div className="flex grow items-center justify-center">
				<Text size="sm" accentColor="base">
					{table.getPageCount() !== 0 ? table.getState().pagination.pageIndex + 1 : 0} /{" "}
					{table.getPageCount()}
				</Text>
			</div>

			<div className="flex grow items-center justify-end gap-2">
				<IconButton aria-label="first page" disabled={!table.getCanPreviousPage()} onClick={table.firstPage}>
					<LuIcon icon={modelIconMapping.chevronsLeft} />
				</IconButton>
				<IconButton
					aria-label="previous page"
					disabled={!table.getCanPreviousPage()}
					onClick={table.previousPage}
				>
					<LuIcon icon={modelIconMapping.chevronLeft} />
				</IconButton>

				<IconButton aria-label="next page" disabled={!table.getCanNextPage()} onClick={table.nextPage}>
					<LuIcon icon={modelIconMapping.chevronRight} />
				</IconButton>
				<IconButton aria-label="last page" disabled={!table.getCanNextPage()} onClick={table.lastPage}>
					<LuIcon icon={modelIconMapping.chevronsRight} />
				</IconButton>
			</div>
		</ButtonGroup>
	)
})
